// fut.gg's rarityEaId for the Gold rarity, mirrored in the backend's players.rarity_id column.
export const GOLD_RARITY_ID = 0;
